/**
 * `/pools/archived`, the Archived pools screen (ISSUE-1343; v1
 * see_all_pool.dart with PoolListType.archive). Reached from the
 * "Archived pools" link under the Pools list. Named `pools_.archived` so it
 * stays out of `/pools`'s two-pane tree, the same convention as
 * `pools_.search.tsx`.
 */
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { requireSignedIn } from "../auth/requireSignedIn";
import { ArchivedPoolsPane } from "../features/pools/ArchivedPoolsPane";
import { BACK_LINK_CLASS } from "../shell/BackLink";
import { SectionScreen } from "../shell/SectionScreen";

export const ARCHIVED_POOLS_HEADING = "Archived pools";
export const ARCHIVED_POOLS_BACK_LABEL = "Back to your pools";

const ArchivedPoolsScreen = (): ReactNode => {
  const navigate = useNavigate({ from: "/pools/archived" });
  return (
    <SectionScreen heading={ARCHIVED_POOLS_HEADING}>
      <Link
        to="/pools"
        className={BACK_LINK_CLASS}
        data-testid="archived-pools-back"
      >
        {ARCHIVED_POOLS_BACK_LABEL}
      </Link>
      <ArchivedPoolsPane
        onSelectPool={(poolId) => {
          void navigate({ to: "/pools", search: { poolId } });
        }}
      />
    </SectionScreen>
  );
};

export const Route = createFileRoute("/pools_/archived")({
  beforeLoad: requireSignedIn,
  component: ArchivedPoolsScreen,
});
